import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=5605bf36&"
import script from "./Attribution.vue?vue&type=script&lang=js&"
export * from "./Attribution.vue?vue&type=script&lang=js&"
import style0 from "./Attribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports